import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";


const name = 'ProdutosInformacao'

export default {
    name,
    components: {
      'g-card':gCard,
      'g-button': gButton,
      'g-form': gForm
    },


mounted (){
  this.getDadosProduto()
  this.getComponentesEInfo()
},

updated () {},

data () {
    return {
      componentesInfos:[],
      nome:'',
      nomeProduto:'',
      quantidade:'',
      curvaClienteDesc:'',
      liquidado:'',
      quantidadeCaixas:'',
      quantidadeFolhas:'',
      quantidadeSaldo:'',
      valorUnitarioCaixa:'',
      valorUnitarioCaixaFormatado: '',
      quantidadePedido:'',
      quantidadeFaturamentoAntecipado:'',
      componenteTipoTexto:'',
      valorFaturamentoAntecipado:'',
      dataEntregaFormatada:'',
      dataCarregamentoFormatada:'',
      dataEstoqueFormatada:'',
      quantidadeProduzida:'',
      quantidadeSobras:'',
      pedidoId:'',
      TotalPedidoParcela:'',
      TotalPedido:'',
      codigoPedido:'',
      codigoProduto:'',
      numeroParcela:'',
      codigoExterno:'',
      quantidadeFolhasTotal:'',
      quantidadeCaixasTotal:'',
      clienteId: null,
      produtoId: null,
    }
},

methods: {
  getDadosProduto(){
    this.$isLoading(true)
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetProdutosEstoqueInformacao/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
    })
    .then((response) => {
      this.pedidoId = response.data.data.pedidoId;
      this.produtoId = response.data.data.produtoId;
      this.clienteId = response.data.data.clienteId;
      this.nome = response.data.data.nomeFantasia;
      this.nomeProduto = response.data.data.nomeProduto;
      this.curvaClienteDesc = response.data.data.curvaClienteDesc;
      this.liquidado = response.data.data.liquidado;
      this.quantidadeCaixas = response.data.data.quantidadeCaixas;
      this.quantidadeSaldo = response.data.data.quantidadeSaldo;
      this.valorUnitarioCaixa = response.data.data.valorUnitarioCaixa;
      this.valorUnitarioCaixaFormatado = response.data.data.valorUnitarioCaixaFormatado;
      this.TotalPedidoParcela = this.valorUnitarioCaixa * this.quantidadeCaixas
      this.TotalPedidoParcela = this.TotalPedidoParcela.toFixed(2).replace('.', ',');
      this.quantidadeFolhas = response.data.data.quantidadeFolhas;
      this.quantidadePedido = response.data.data.quantidadePedido;
      this.quantidadeFaturamentoAntecipado = response.data.data.quantidadeFaturamentoAntecipado;
      this.valorFaturamentoAntecipado = response.data.data.valorFaturamentoAntecipado;
      this.dataEntregaFormatada = response.data.data.dataEntregaFormatada;
      this.dataCarregamentoFormatada = response.data.data.dataCarregamentoFormatada;
      this.dataEstoqueFormatada = response.data.data.dataEstoqueFormatada;
      this.codigoExterno = response.data.data.codigoExterno;
      this.codigoProduto = response.data.data.codigoProduto;
      this.numeroParcela = response.data.data.numeroParcela;
      this.codigoPedido = response.data.data.numeroPedido;
      this.getValoresTotais()
    })
    .finally(()=> {
      this.$isLoading(false)
    })
  },

  getComponentesEInfo(){
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetComponentesProdutoEstoque/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
    })
    .then((response) => {
      this.componenteTipoTexto = response.data.data.componenteTipoTexto;
      this.quantidadeProduzida = response.data.data.quantidadeProduzida;
      this.quantidadeSobras = response.data.data.quantidadeSobras;
    })
    .catch(() => {
    });
  },

  getValoresTotais(){
    let ProdutoId = this.produtoId;
    let ClienteId = this.clienteId;
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetValoresTotaisProdutosEstoqueInformacao/${ProdutoId}/${ClienteId}`,
    })
    .then((response) => {
      this.quantidadeCaixasTotal = response.data.data.quantidadeCaixasTotal;
      this.quantidadeFolhasTotal = response.data.data.quantidadeFolhasTotal;
      this.TotalPedido = this.valorUnitarioCaixa * this.quantidadeCaixasTotal;
      this.TotalPedido = this.TotalPedido.toFixed(2).replace('.', ',');
    })
   .catch(() => {
    });
  },

  voltar (){
    this.$router.push(`/produtos-estoque`)
  },

},
}
